
import { Type } from '@angular/core';
import { AbstractFormFieldComponent } from '../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { FormFieldModel } from '../../../Common/PageBuilder/models/form-field.model';
import { LayoutBlockDisplayRatiosEnum } from '../enums/layout-block-display-ratios.enum';
import { StyleTypesApiEnum } from '../../../api/styles/enum/style-types-api.enum';
import { DropdownOptionModel } from '../../../Common/Forms/models/dropdown-option.model';

export class LayoutStyleField implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    columnNumber: number;
    styleType: StyleTypesApiEnum;
    allowExpertMode?: boolean = true;
    changeDefaultStyleStateOptions?: (x: any) => DropdownOptionModel[];

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        columnNumber: number,
        changeDefaultStyleStateOptions?: (x: any) => DropdownOptionModel[]
    ) {
        this.fieldComponent = fieldComponent;
        this.property = 'styles';
        this.columnNumber = columnNumber;
        this.styleType = columnNumbersToStyleTypesMap.get(this.columnNumber);
        this.changeDefaultStyleStateOptions = changeDefaultStyleStateOptions;
    }
}


export const columnNumbersToDisplayRatiosMap: Map<number, LayoutBlockDisplayRatiosEnum[]> = new Map([
    [ 1, [] ],
    [
        2,
        [
            LayoutBlockDisplayRatiosEnum.ONE_TO_ONE,
            LayoutBlockDisplayRatiosEnum.THREE_TO_SEVEN,
            LayoutBlockDisplayRatiosEnum.SEVEN_TO_THREE,
            LayoutBlockDisplayRatiosEnum.TWO_TO_EIGHT,
            LayoutBlockDisplayRatiosEnum.EIGHT_TO_TWO
        ]
    ],
    [
        3,
        [
            LayoutBlockDisplayRatiosEnum.ONE_TO_ONE_TO_ONE,
            LayoutBlockDisplayRatiosEnum.TWO_TO_SIX_TO_TWO,
            LayoutBlockDisplayRatiosEnum.TWO_TO_TWO_TO_SIX,
            LayoutBlockDisplayRatiosEnum.SIX_TO_TWO_TO_TWO
        ]
    ]
]);

export const displayRatiosToColumnNumbersMap: Map<LayoutBlockDisplayRatiosEnum, number> = new Map([
    [LayoutBlockDisplayRatiosEnum.ONE_TO_ONE, 2],
    [LayoutBlockDisplayRatiosEnum.THREE_TO_SEVEN, 2],
    [LayoutBlockDisplayRatiosEnum.SEVEN_TO_THREE, 2],
    [LayoutBlockDisplayRatiosEnum.TWO_TO_EIGHT, 2],
    [LayoutBlockDisplayRatiosEnum.EIGHT_TO_TWO, 2],
    [LayoutBlockDisplayRatiosEnum.ONE_TO_ONE_TO_ONE, 3],
    [LayoutBlockDisplayRatiosEnum.TWO_TO_SIX_TO_TWO, 3],
    [LayoutBlockDisplayRatiosEnum.TWO_TO_TWO_TO_SIX, 3],
    [LayoutBlockDisplayRatiosEnum.SIX_TO_TWO_TO_TWO, 3]
]);

export const columnNumbersToStyleTypesMap: Map<number, StyleTypesApiEnum> = new Map([
    [1, StyleTypesApiEnum.ONE_COLUMN_LAYOUT],
    [2, StyleTypesApiEnum.TWO_COLUMN_LAYOUT],
    [3, StyleTypesApiEnum.THREE_COLUMN_LAYOUT]
]);

